import type { TournamentDollarLedgerGetPayload, TournamentTicketGetPayload } from '@repo/database/src/types';

import { TournamentWComputed } from '../../tournament-types';

export interface GetTicketsParams {
  skip?: number;
  take?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  filters?: {
    displayName?: string;
    userId?: string;
    type?: string[];
    status?: string[];
    templateId?: string;
    tournamentId?: string;
    used?: boolean;
    expired?: boolean;
    expiresAt?: { from?: Date; to?: Date };
  };
}

export type TournamentTicketDto = TournamentTicketGetPayload<{
  include: {
    tournament: true;
  };
}> & { tournament: TournamentWComputed };

export interface GetTournamentDollarLedgerParams {
  skip?: number;
  take?: number;
  sortBy?: 'createdAt' | 'amount' | 'type';
  sortOrder?: 'asc' | 'desc';
}

export type TournamentDollarLedgerDto = TournamentDollarLedgerGetPayload<{
  include: {
    tournament: {
      select: {
        id: true;
        name: true;
      };
    };
  };
}>;

export interface GetTournamentDollarLedgerResponse {
  data: TournamentDollarLedgerDto[];
  total: number;
  skip: number;
  take: number;
  balance: number;
}

export enum TournamentCurrencyLedgerType {
  TICKET_RECEIVED = 'TICKET_RECEIVED',
  TICKET_USED = 'TICKET_USED',
  TD_CREDIT = 'TD_CREDIT',
  TD_DEBIT = 'TD_DEBIT',
}

export interface TournamentCurrencyLedgerEntryDto {
  type: TournamentCurrencyLedgerType;
  date: Date;
  amount: number | null;
  tournamentId: string | null;
  tournamentName: string | null;
  tdBalanceAfter: number | null;
  referenceType: string | null;
  referenceId: string | null;
  transactionId: string | null;
  note: string | null;
}

export interface GetTournamentCurrencyLedgerParams {
  skip?: number;
  take?: number;
}

export interface GetTournamentCurrencyLedgerResponse {
  data: TournamentCurrencyLedgerEntryDto[];
  total: number;
  skip: number;
  take: number;
  tdBalance: number;
}
